/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import SelectDevice from '@root/containers/ApplePay/SelectDevice';

const ApplePaySelectDevice = () => {
  return <SelectDevice />;
};

export default ApplePaySelectDevice;
